import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HasItemPipe } from "./has-item/has-item.pipe";
import { LengthPipe } from "./length/length.pipe";
import { FilterByPipe } from "./filter-by/filter-by.pipe";
import { FindByPipe } from "./find-by/find-by.pipe";
import { IsArrayPipe } from "./is-array/is-array.pipe";
import { OrderByPipe } from "./order-by/order-by.pipe";
import { SumByPipe } from "./sum-by/sum-by.pipe";
import { FlatMapPipe } from "./flat-map/flat-map.pipe";
import { TimeFormatPipe } from "./time-format/time-format.pipe";
import { ReadableTimePipe } from "./readable-time/readable-time.pipe";

@NgModule({
  imports: [CommonModule],
  exports: [
    HasItemPipe,
    LengthPipe,
    IsArrayPipe,
    FilterByPipe,
    OrderByPipe,
    SumByPipe,
    FlatMapPipe,
    FindByPipe,
    TimeFormatPipe,
    ReadableTimePipe
  ],
  declarations: [
    HasItemPipe,
    LengthPipe,
    FilterByPipe,
    IsArrayPipe,
    OrderByPipe,
    SumByPipe,
    FlatMapPipe,
    FindByPipe,
    TimeFormatPipe,
    ReadableTimePipe
  ]
})
export class PipesModule {}
